import React from "react";
import { FilterCount, FilterPill, FiltersRow } from "./styles";
import { NotificationFilter } from "./types";

type Props = {
  activeFilter: NotificationFilter;
  allCount: number;
  unreadCount: number;
  onChange: (filter: NotificationFilter) => void;
};

const NotificationFilters = ({
  activeFilter,
  allCount,
  unreadCount,
  onChange,
}: Props) => {
  return (
    <FiltersRow>
      <FilterPill
        type="button"
        $active={activeFilter === "all"}
        onClick={() => onChange("all")}
      >
        All
        <FilterCount $active={activeFilter === "all"}>{allCount}</FilterCount>
      </FilterPill>
      <FilterPill
        type="button"
        $active={activeFilter === "unread"}
        onClick={() => onChange("unread")}
      >
        Unread
        <FilterCount $active={activeFilter === "unread"}>
          {unreadCount}
        </FilterCount>
      </FilterPill>
    </FiltersRow>
  );
};

export default NotificationFilters;
